import { AlertCircle } from 'lucide-react';

interface ErrorPageProps {
  error: Error;
}

export default function ErrorPage({ error }: ErrorPageProps) {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
      <div className="text-center max-w-md">
        {/* Error Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-6">
          <AlertCircle className="w-10 h-10 text-red-600" />
        </div>

        {/* Error Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          發生錯誤
        </h1>

        {/* Error Message */}
        <p className="text-gray-600 mb-2">
          {error.message || '應用程式初始化失敗'}
        </p>

        {/* Technical Details (可收合) */}
        <details className="text-left bg-gray-100 rounded-lg p-4 mb-6 text-sm">
          <summary className="cursor-pointer font-medium text-gray-700 mb-2">
            技術細節
          </summary>
          <pre className="text-xs text-gray-600 overflow-x-auto whitespace-pre-wrap">
            {error.stack || error.toString()}
          </pre>
        </details>

        {/* Actions */}
        <button
          onClick={handleReload}
          className="btn-primary w-full"
        >
          重新載入
        </button>

        <p className="text-sm text-gray-500 mt-4">
          如果問題持續發生，請聯繫客服
        </p>
      </div>
    </div>
  );
}
